interface FooterProps {
  onFeedbackClick: () => void
}

export const Footer = ({ onFeedbackClick }: FooterProps) => (
  <div className="absolute bottom-0 left-0 right-0 p-3 bg-gray-100 border-t border-gray-200">
    <div className="flex items-center justify-between px-4">
      <p className="text-xs text-gray-600">© {new Date().getFullYear()}</p>
      <p className="text-xs text-gray-600">
        Created by{' '}
        <a
          href="https://www.studioqdesigns.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-primary underline"
        >
          Studio Q Designs Inc.
        </a>
      </p>
      <button onClick={onFeedbackClick} className="text-xs text-gray-600 hover:text-brand-primary underline">
        Share Feedback
      </button>
    </div>
  </div>
)
